'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _Typography = require('../../src/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EndorseContentLayout = function EndorseContentLayout(_ref) {
  var head = _ref.head,
      content = _ref.content,
      primaryCta = _ref.primaryCta,
      secondaryCta = _ref.secondaryCta;
  return _react2.default.createElement(
    'div',
    { className: _styles2.default.root },
    head && _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_styles2.default.head, _Typography2.default.h1) },
      head
    ),
    content && _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_styles2.default.content, _Typography2.default.t1) },
      content
    ),
    primaryCta && _react2.default.createElement(
      'div',
      { className: _styles2.default.primaryCta },
      primaryCta
    ),
    secondaryCta && _react2.default.createElement(
      'div',
      { className: _styles2.default.secondaryCta },
      secondaryCta
    )
  );
};

EndorseContentLayout.propTypes = {
  head: _propTypes2.default.node,
  content: _propTypes2.default.node,
  primaryCta: _propTypes2.default.node,
  secondaryCta: _propTypes2.default.node
};

exports.default = EndorseContentLayout;